import { Button } from "@components/components/ui/button";

export interface TopicOption {
  name: string;
  count: number;
  lastFetchedAt?: string | null;
}

interface TopicPillsProps {
  topics: TopicOption[];
  active: string | null;
  onSelect: (value: string | null) => void;
}

export function TopicPills({ topics, active, onSelect }: TopicPillsProps) {
  return (
    <div className="sticky top-[73px] z-10 -mx-4 overflow-x-auto px-4 py-2 sm:mx-0 sm:px-0 bg-slate-100/95 backdrop-blur sm:bg-transparent sm:backdrop-filter-none">
      <div className="flex min-w-max gap-2 sm:flex-wrap">
        <Button
          variant={active === null ? "default" : "outline"}
          size="sm"
          onClick={() => onSelect(null)}
          className={`rounded-full ${
            active === null
              ? "bg-accent text-white hover:bg-accent/90 shadow-md shadow-accent/20 border-transparent"
              : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-slate-900"
          }`}
        >
          全部
        </Button>
        {topics.map((topic) => {
          const isActive = topic.name === active;
          return (
            <Button
              key={topic.name}
              variant={isActive ? "default" : "outline"}
              size="sm"
              onClick={() => onSelect(isActive ? null : topic.name)}
              className={`rounded-full ${
                isActive
                  ? "bg-accent text-white hover:bg-accent/90 shadow-md shadow-accent/20 border-transparent"
                  : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-slate-900"
              }`}
            >
              {topic.name}
              <span className={`ml-2 text-[10px] ${isActive ? "text-slate-200" : "text-slate-400"}`}>
                {topic.count}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}